export enum SubscriptionType {
    Subscriber = 1, 
    Beneficiary = 2, 
}